import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Swiper from "react-id-swiper"

import Heading, { Type } from "../../UI/Heading"
import Modal from "../../UI/Modal"

import {
  Section,
  Container,
  Content,
  Image,
  Description,
  VideoElement,
  PlayIcon,
  ModalButton,
  ModalContent,
  VideoTeaser,
  VideoPlayer
} from "./styles"

import { videoPath } from "../../../constants"
import play from "../../../assets/play.svg"
import close from "../../../assets/close-white.svg"

const VideoGrid = ({ backgroundColor, textColor, videos }) => {

  // State
  const [modalOpen, setModalOpen] = useState(false)
  const [activeVideo, setActiveVideo] = useState({ id: null, src: null })

  // Actions
  const onModalOpen = (id, src) => {
    setActiveVideo({ id, src })
    setModalOpen(true)
  }
  const onModalClose = () => setModalOpen(false)

  // Modal open
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.code === "Escape") {
        onModalClose()
      }
    }

    // Freeze content when modal is open
    document.body.style.overflow = modalOpen ? "hidden" : ""

    if (modalOpen) {
      window.addEventListener("keydown", handleKeyDown)

      // cleanup this component
      return () => window.removeEventListener("keydown", handleKeyDown)
    }
  }, [modalOpen])

  // Slider params
  const params = {
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 48,
      },
    },
  }

  return (
    <Section color={backgroundColor}>
      <Container>
        <Swiper {...params}>
          {videos.map(({ title, text, image, id, video }) => (
            <VideoTeaser key={id}>
              <VideoElement onClick={() => onModalOpen(id, video)}>
                <PlayIcon src={play} alt="play" />
                <Image fluid={image.childImageSharp.fluid} alt={image.name} />
              </VideoElement>
              <Content color={textColor}>
                <Heading type={Type.h2}>{title}</Heading>
                <Description>{text}</Description>
              </Content>
            </VideoTeaser>
          ))}
        </Swiper>
      </Container>
      <Modal isOpen={modalOpen}>
        <ModalButton role="button" tabIndex={0} onClick={onModalClose}>
          <img src={close} alt="close" />
        </ModalButton>
        <ModalContent>
          {modalOpen && (
            <VideoPlayer
              width={1200}
              key={activeVideo.id}
              className="video-player"
              video={`${videoPath}/${activeVideo.src}`}
              autoplay
            />
          )}
        </ModalContent>
      </Modal>
    </Section>
  )
}

VideoGrid.propTypes = {
  videos: PropTypes.array,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
}

export default VideoGrid
